import { createSlice } from "@reduxjs/toolkit";
import { getCuisineListAPI } from "../../api/chef";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
}; 

const getCuisineListSlice = createSlice({
  name: "getCuisineList",
  initialState: data,
  reducers: {
   getCuisineListSlice(state) {
      state.isLoading = true;
    },
   getCuisineListSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    getCuisineListSliceFailure(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    getCuisineListSliceReset(state) {
      state.isLoading = false;
      state.data = null;
    },
  },
});
export const getCuisineListHandler = () => async (dispatch: any) => {
  try {
    dispatch(getCuisineListAction.getCuisineListSlice());
    const response: any = await getCuisineListAPI();
    
    dispatch(getCuisineListAction.getCuisineListSliceSuccess(response));
  } catch (e: any) {
    dispatch(getCuisineListAction.getCuisineListSliceFailure(e?.response?.data));
  }
};
export default getCuisineListSlice.reducer;
export const getCuisineListAction = getCuisineListSlice.actions;
